import cookieUtils from "../util/cookieUtils";

export default {
    mounted() {}
};